exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dyna-app-ie11-sucks-banner {\n  display: flex;\n  background-color: maroon;\n  color: white;\n  padding: 16px;\n}\n.dyna-app-ie11-sucks-banner__icon {\n  flex: 1 1 auto;\n  margin-right: 16px;\n  font-size: 52px;\n}\n.dyna-app-ie11-sucks-banner__message {\n  flex: 1 1 100%;\n  white-space: pre-wrap;\n}\n", ""]);

// exports
